/**
 * @generated SignedSource<<575fccb0ea91a512daee1ce03848f428>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type SyncJiraDataInput = {
  jiraProjectId?: string | null;
  jiraEpicIds?: ReadonlyArray<string | null> | null;
  forecastProjectId?: string | null;
  boardId?: string | null;
  subtaskType?: string | null;
  epicType?: string | null;
  type?: string | null;
  estimationField?: string | null;
  name?: string | null;
  projectColor?: string | null;
  labels?: ReadonlyArray<string | null> | null;
  sprintTimeBox?: boolean | null;
  sprintLengthInDays?: number | null;
  projectStartDay?: number | null;
  projectStartMonth?: number | null;
  projectStartYear?: number | null;
  projectEndDay?: number | null;
  projectEndMonth?: number | null;
  projectEndYear?: number | null;
  rateCardId?: string | null;
  statusColumns?: ReadonlyArray<StatusColumnInput | null> | null;
  useManualAllocations?: boolean | null;
  budgetType?: BUDGET_TYPE | null;
  clientId?: string | null;
  budget?: number | null;
  defaultPeriodPriceAmount?: number | null;
  defaultPeriodHoursAmount?: number | null;
  defaultPeriodBudgetType?: PERIOD_BUDGET_TYPE | null;
  defaultPeriodLength?: number | null;
  defaultPeriodPeriodicity?: PERIODICITY | null;
  defaultPeriodSettingIgnoreForBilling?: boolean | null;
  defaultPeriodSettingSubtractValue?: boolean | null;
  defaultPeriodSettingRollValue?: boolean | null;
  defaultPeriodSettingAddExpenses?: boolean | null;
  remainingField?: string | null;
  jiraTypeToPhase?: string | null;
  cutoffDate?: string | null;
  useBaseline?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StatusColumnInput = {
  id?: string | null;
  name?: string | null;
  order?: number | null;
  category?: string | null;
  projectId?: string | null;
  projectGroupStatusColumnId?: number | null;
  autoShowOnTimePage?: boolean | null;
  encourageTimeRegistration?: boolean | null;
};
export type syncJiraIntegrationMutation$variables = {
  input: SyncJiraDataInput;
};
export type syncJiraIntegrationMutation$data = {
  readonly syncJiraData: {
    readonly company: {
      readonly unSynchedJiraProjects: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly style: string | null;
      } | null> | null;
      readonly unSynchedJiraServerProjects: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
      } | null> | null;
    } | null;
    readonly project: {
      readonly id: string;
      readonly isJiraProject: boolean | null;
      readonly jiraCloudProject: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
      readonly jiraServerProject: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly remainingAutoCalculated: boolean | null;
      readonly jiraSyncRemaining: boolean | null;
      readonly jiraCutoffDate: string | null;
    } | null;
    readonly projectEdge: {
      readonly node: {
        readonly id: string;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly stage: {
          readonly id: string;
          readonly name: string | null;
          readonly profile: PROJECT_STATUS | null;
        } | null;
        readonly name: string | null;
        readonly isJiraProject: boolean | null;
        readonly projectColor: string | null;
        readonly isInProjectGroup: boolean | null;
        readonly billable: boolean | null;
        readonly budgetType: BUDGET_TYPE | null;
        readonly projectGroupId: string | null;
        readonly sprintTimeBox: boolean | null;
        readonly harvestProject: {
          readonly id: string;
        } | null;
        readonly jiraCloudProject: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
        readonly jiraServerProject: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly jiraCutoffDate: string | null;
        readonly statusColumnsV2: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly projectGroupStatusColumnId: number | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type syncJiraIntegrationMutation = {
  variables: syncJiraIntegrationMutation$variables;
  response: syncJiraIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraCloudProjectType",
  "kind": "LinkedField",
  "name": "unSynchedJiraProjects",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraServerProjectType",
  "kind": "LinkedField",
  "name": "unSynchedJiraServerProjects",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraCloudProjectType",
  "kind": "LinkedField",
  "name": "jiraCloudProject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudEpicIds",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraServerProjectType",
  "kind": "LinkedField",
  "name": "jiraServerProject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCutoffDate",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingAutoCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraSyncRemaining",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profile",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1000
    }
  ],
  "concreteType": "StatusColumnV2TypeConnection",
  "kind": "LinkedField",
  "name": "statusColumnsV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2TypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusColumnV2",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectGroupStatusColumnId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "statusColumnsV2(first:1000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "syncJiraIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SyncJiraDataPayload",
        "kind": "LinkedField",
        "name": "syncJiraData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectTypeEdge",
            "kind": "LinkedField",
            "name": "projectEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "stage",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v7/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "syncJiraIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SyncJiraDataPayload",
        "kind": "LinkedField",
        "name": "syncJiraData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectTypeEdge",
            "kind": "LinkedField",
            "name": "projectEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "stage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v7/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a9d6592609fe8bc2add4c76f7fc4039e",
    "id": null,
    "metadata": {},
    "name": "syncJiraIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation syncJiraIntegrationMutation(\n  $input: SyncJiraDataInput!\n) {\n  syncJiraData(input: $input) {\n    company {\n      unSynchedJiraProjects {\n        id\n        name\n        style\n      }\n      unSynchedJiraServerProjects {\n        id\n        name\n      }\n      id\n    }\n    project {\n      id\n      isJiraProject\n      jiraCloudProject {\n        id\n        name\n      }\n      jiraCloudEpicIds\n      jiraServerProject {\n        id\n        name\n      }\n      remainingAutoCalculated\n      jiraSyncRemaining\n      jiraCutoffDate\n    }\n    projectEdge {\n      node {\n        id\n        companyProjectId\n        customProjectId\n        stage {\n          __typename\n          id\n          name\n          profile\n        }\n        name\n        isJiraProject\n        projectColor\n        isInProjectGroup\n        billable\n        budgetType\n        projectGroupId\n        sprintTimeBox\n        harvestProject {\n          id\n        }\n        jiraCloudProject {\n          id\n          name\n        }\n        jiraCloudEpicIds\n        jiraServerProject {\n          id\n          name\n        }\n        jiraCutoffDate\n        statusColumnsV2(first: 1000) {\n          edges {\n            node {\n              id\n              projectGroupStatusColumnId\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7acd341b457816f7b3a7036d7745fbd4";

export default node;
